/**
 * Only your customers can answer this (SYR-111 v3, Group C).
 *
 * Loyalty, belonging, seeing yourself in the brand, whether the ads are
 * creative. A model answering as itself has no referent for any of it, so the
 * AI read does not ask these at all. The page lists them as the next step:
 * the survey is already built from these statements.
 */

import React from 'react';
import { Card } from '../../atoms';
import { THEME } from '../../config/theme';
import { getDisplayName } from '../../../../utils/elementDisplayNames';
import { groupByCategory } from './beliefCells';
import { ReadSection } from './ReadSection';

interface Props {
  notAsked: { code: string; category: string; group: string | null; text: string }[];
  hasSurvey: boolean;
  // The section's number; one later when the read has a pages section.
  n?: string;
}

export const SurveyOnly: React.FunctionComponent<Props> = ({ notAsked, hasSurvey, n = '4' }) => {
  if (!notAsked?.length) return null;
  const groups = groupByCategory(notAsked);

  return (
    <ReadSection
      id="customers-only"
      n={n}
      tone="#64748B"
      title="What only your customers can tell you"
      sub={
        hasSurvey
          ? 'These statements are not put to the models. A model has no loyalty and no sense of belonging, and its guess at how your customers feel is no substitute for asking them. Your survey already measures them: see The Detail for how your customers answered.'
          : 'These statements are not put to the models. A model has no loyalty and no sense of belonging, and its guess at how your customers feel is no substitute for asking them. The survey built from these statements is ready to send, and once it has answers the customer line appears beside the models’ line above.'
      }
    >
      <Card>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 18 }}>
          {groups.map((group) => (
            <div key={group.category}>
              <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: THEME.textMuted, marginBottom: 8 }}>
                {getDisplayName(group.category)}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {group.rows.map((row) => (
                  <div key={row.code} style={{ fontSize: 13, color: THEME.textSecondary, lineHeight: 1.45, paddingLeft: 12, position: 'relative' }}>
                    <span style={{ position: 'absolute', left: 0, top: 8, width: 5, height: 5, borderRadius: '50%', background: '#CBD5E1' }} />
                    {row.text}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Card>
    </ReadSection>
  );
};
